import { styled } from '@mui/material';
import { ManagementSectionBody, ManagementSectionContainer } from '../styles';

export const JointCommissionsContainer = styled(ManagementSectionContainer)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: '4px',
}));

export const JointCommissionsBody = styled(ManagementSectionBody)({
  padding: 0,
});
